import api from '../api'
import config from '../config'

export default {
  request(method, uri, data = null) {
    var requestMethod = method
    var requestUri = uri
    var requestData = data
    var headers = null

      // Verifica se o token existe e se o mesmo esta válido
    if (window.localStorage.getItem('token') !== 'null' && window.localStorage.getItem('token') !== null) {
      var token = window.localStorage.getItem('token')
      var tokenParts = token.split('.')
      var body = JSON.parse(atob(tokenParts[1]))
      var date = new Date(0)
      date.setUTCSeconds(body.exp)
      // Verificando expiração do Token
      if (date < new Date()) {
        console.log('expiration')
        var refreshToken = window.localStorage.getItem('refresh_token')
        method = 'post'
        var url = config.renewTokenURI
        data = 'grant_type=refresh_token&refresh_token=' + refreshToken
        headers = {'Authorization': 'Basic d2ViOndlYg==', 'Content-Type': 'application/x-www-form-urlencoded'}
        api.request(method, url, data, headers)
        .then(response => {
          window.localStorage.setItem('user', JSON.stringify(response.data.nome))
          window.localStorage.setItem('token', response.data.access_token)
          window.localStorage.setItem('refresh_token', response.data.refresh_token)
          var tokenParts = response.data.access_token.split('.')
          var body = JSON.parse(atob(tokenParts[1]))
          window.localStorage.setItem('role', body.authorities[0])
          headers = { 'Authorization': 'Bearer ' + window.localStorage.getItem('token'), 'Content-Type': 'application/json' }
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('SET_USER', null)
          this.$store.commit('SET_TOKEN', null)
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
          window.localStorage.setItem('refresh_token', null)
          window.localStorage.setItem('role', null)
          this.$router.push('/login')
        })
      } else {
        headers = { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
      }
    }
    url = requestUri
    return api.request(requestMethod, url, requestData, headers)
  }
}



// WEBPACK FOOTER //
// ./src/interceptor/index.js